import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutPayAdjustmentCodeList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceDeductCode: DataSource;
    tablePayAdjustmentCodes: Table;
}
